import * as v from "valibot";
import { rpcContract } from "../rpc";

export const deleteLiveEventRpcContract = rpcContract({
  name: "delete-live-event",
  paramsSchema: v.object({
    event_id: v.string(),
  }),
  resultSchema: v.object({
    success: v.boolean(),
    message: v.optional(v.string()),
  }),
});

export type DeleteLiveEventParams = v.InferOutput<(typeof deleteLiveEventRpcContract)["paramsSchema"]>;
export type DeleteLiveEventResult = v.InferOutput<(typeof deleteLiveEventRpcContract)["resultSchema"]>;
